import { render, staticRenderFns } from "./PriceIndexation.vue?vue&type=template&id=09f5e82c&"
import script from "./PriceIndexation.vue?vue&type=script&lang=js&"
export * from "./PriceIndexation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports